import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { tokenStore } from "../api/client";
import { authApi } from "../api/authApi";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const logout = useCallback(() => {
    tokenStore.clear();
    setUser(null);
  }, []);

  const loadMe = useCallback(async () => {
    if (!tokenStore.access() && !tokenStore.refresh()) { setLoading(false); return; }
    try {
      const { data } = await authApi.me();
      setUser(data);
    } catch { logout(); }
    finally { setLoading(false); }
  }, [logout]);

  useEffect(() => { loadMe(); }, [loadMe]);
  useEffect(() => {
    window.addEventListener("barberiant:logout", logout);
    return () => window.removeEventListener("barberiant:logout", logout);
  }, [logout]);

  const login = async (username, password) => {
    const { data: tokens } = await authApi.login({ username, password });
    tokenStore.save(tokens);
    const { data } = await authApi.me();
    setUser(data);
    return data;
  };

  const value = useMemo(() => ({ user, role: user?.rol, loading, login, logout, refreshUser: loadMe }), [user, loading, logout, loadMe]);
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);



